export const loadSelectedUserClients = (payload) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_CLIENTS',
    payload,
});
export const loadUserClientsSuccess = (userClients) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_CLIENTS_SUCCESS',
    payload: { userClients },
});
export const loadUserClientsError = (error) => ({
    type: 'OLY_ENGINE_STORE_LOAD_USER_CLIENTS_ERROR',
    payload: { error },
});
export const setCurrentUserClientId = (clientId) => ({
    type: 'OLY_ENGINE_STORE_SET_CURRENT_USER_CLIENT_ID',
    payload: { clientId },
});
export const resetUserClients = () => ({
    type: 'OLY_ENGINE_STORE_RESET_USER_CLIENTS',
});
export const loadOneUserClient = (payload) => ({
    type: 'OLY_LOAD_ONE_USER_CLIENT',
    payload,
});
export const loadOneUserClientSuccess = (userClient) => ({
    type: 'OLY_LOAD_ONE_USER_CLIENT_SUCCESS',
    payload: { userClient },
});
export const loadOneUserClientError = (error) => ({
    type: 'OLY_LOAD_ONE_USER_CLIENT_ERROR',
    payload: { error },
});
export const updateUserClientSettings = (payload) => ({
    type: 'OLY_UPDATE_USER_CLIENT_SETTINGS',
    payload,
});
export const updateUserClientSettingsSuccess = (settings) => ({
    type: 'OLY_UPDATE_USER_CLIENT_SETTINGS_SUCCESS',
    payload: { settings },
});
export const updateUserClientSettingsError = (error) => ({
    type: 'OLY_UPDATE_USER_CLIENT_SETTINGS_ERROR',
    payload: { error },
});
export default {
    loadSelectedUserClients,
    loadUserClientsSuccess,
    loadUserClientsError,
    setCurrentUserClientId,
    resetUserClients,
    loadOneUserClient,
    loadOneUserClientSuccess,
    loadOneUserClientError,
    updateUserClientSettings,
    updateUserClientSettingsSuccess,
    updateUserClientSettingsError,
};
